import getHostnameWithoutLocal from './getHostnameWithoutLocal';
import removeExoPrefixIfNeeded from './removeExoPrefixIfNeeded';
import safeGetHostname from './safeGetHostname';
import safeGetPathname from './safeGetPathname';
const urlMatchesCurrentHostname = url => {
  const hostname = safeGetHostname(url);
  if (hostname) {
    return hostname === getHostnameWithoutLocal();
  }
  return true;
};
const urlMatchesCurrentPathname = url => {
  return removeExoPrefixIfNeeded(window.location.pathname).startsWith(safeGetPathname(url));
};
export default currentProject => {
  const product = currentProject === null || currentProject === void 0 ? void 0 : currentProject.products.find(p => {
    return p.defaultUrl && urlMatchesCurrentHostname(p.defaultUrl) && urlMatchesCurrentPathname(p.defaultUrl) || p.tools.some(t => t.url && urlMatchesCurrentHostname(t.url) && urlMatchesCurrentPathname(t.url));
  });
  return product === null || product === void 0 ? void 0 : product.key;
};
//# sourceMappingURL=getCurrentProductId.js.map